<template>
  <div class="text-center">
    <Icon
      :width="30"
      :height="30"
      class="mb-4"
      :color="'rgba(0,0,0,.54)'"
      :icon="icon ? icon : 'alert-decagram-outline'"
    />

    <h3 style="color: #444">
      {{ title ? title : $t('empty.title') }}
    </h3>

    <h4 class="font-weight-regular text--secondary">
      {{ description ? description : $t('empty.description') }}
    </h4>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    icon: {
      type: String,
      default: 'alert-decagram-outline'
    },
    title: {
      type: String
    },
    description: {
      type: String
    }
  }
})
export default class Empty extends Vue {}
</script>
